import store from 'store';

export const hasPermissions = permissions => {
  const states = store.getState();
  const { user } = states.auth;

  if (permissions === null) return true;

  if (typeof permissions === 'string') {
    return user.data.id && user.data.attributes.access.roles.find(role => role.alias === permissions) !== undefined;
  } else {
    return !!permissions.filter(
      permission =>
        user.data.id && user.data.attributes.access.roles.find(role => role.alias === permission) !== undefined,
    ).length;
  }
};

export const lockedStore = (values = false) => {
  const states = store.getState();
  const { user } = states.auth;
  const { extra_data } = user.data.attributes.access;

  const hasStorePlace = Boolean(extra_data?.locks?.store_place);

  if (!hasStorePlace) {
    return false;
  }

  const { id, name } = extra_data.locks.store_place;

  return values ? { value: id, label: name } : hasStorePlace;
};

export const lockedLocal = (values = false) => {
  const states = store.getState();
  const { user } = states.auth;
  const { extra_data } = user.data.attributes.access;

  const hasFeedLocal = Boolean(extra_data?.locks?.feed_local);

  if (!hasFeedLocal) {
    return false;
  }

  const { id, name } = extra_data.locks.feed_local;

  return values ? { value: id, label: name } : hasFeedLocal;
};

export const lockedChannel = (values = false) => {
  const states = store.getState();
  const { user } = states.auth;
  const { extra_data } = user.data.attributes.access;

  const hasStoreChannel = Boolean(extra_data?.locks?.store_channel);

  if (!hasStoreChannel) {
    return false;
  }

  const { id, name } = extra_data.locks.store_channel;

  return values ? { value: id, label: name } : hasStoreChannel;
};

export const lockedProductType = (values = false) => {
  const states = store.getState();
  const { user } = states.auth;
  const { extra_data } = user.data.attributes.access;

  const hasStoreProductType = Boolean(extra_data?.locks?.store_product_type);

  if (!hasStoreProductType) {
    return false;
  }

  const { id, name } = extra_data.locks.store_product_type;

  return values ? { value: id, label: name } : hasStoreProductType;
};

export const lockedSection = (values = false) => {
  const states = store.getState();
  const { user } = states.auth;
  const { extra_data } = user.data.attributes.access;

  const hasStoreSection = Boolean(extra_data?.locks?.store_section);

  if (!hasStoreSection) {
    return false;
  }

  const { id, name } = extra_data.locks.store_section;

  return values ? { value: id, label: name } : hasStoreSection;
};
